    <div class=" content">
        <h1 class="title">Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p>des Anbieters ({{getCompany()}}) für Verbraucher (B2C) und Unternehmer (B2B)</p>

        <h3>1. Geltungsbereich und Anbieter</h3>
<p>
    Die nachfolgenden Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Bestellungen durch Verbraucher (§ 13 BGB) und Unternehmer (§ 14 BGB), die Kunden über den Online-Shop (<strong>{{getCompany()}}</strong>) , auf der Plattform "webDrink" (www.webdrink.de) abgeben.

</p>

        <h3>2. Vertragspartner und Vertragsschluss</h3>
        <p>

            <b>2.1</b><br>

            Die Angebote des Onlineshops im Internet stellen eine unverbindliche Aufforderung an den Kunden dar, im Onlineshop Waren zu bestellen.<br><br>



            <b>2.2</b><br>

            Durch die Bestellung der gewünschten Waren im Internet gibt der Kunde ein verbindliches Angebot auf Abschluss eines Kaufvertrages ab.
            <br><br>


            <b>2.3</b><br>

            Der Onlineshop bestätigt den Zugang der Bestellung unverzüglich, spätestens 2 Stunden nach Zugang der Bestellung. Die Bestellbestätigung wie auch die Entgegennahme einer telefonischen Bestellung, stellen noch keine rechtsgeschäftliche Annahme unsererseits dar. Der Kaufvertrag kommt mit der Zusendung einer separaten Auftragsbestätigung oder spätestens mit der Lieferung der Waren zustande. Wir behalten uns vor, Ihr Vertragsangebot nicht anzunehmen.
            <br><br>


            <b>2.4</b><br>

            Vertragsgegenstand ist die vom Kunden bestellte Ware. Bezüglich der Beschaffenheit gilt die Angebotsbeschreibung, im Übrigen gilt § 434 Abs.1 Satz 3 BGB.

        </p>

        <h3>3. Vertragssprache</h3>
        <p>Vertragssprache ist deutsch.</p>

        <h3>4. Widerrufsrecht für Verbraucher</h3>
        <p>Verbrauchern steht das gesetzliche Widerrufsrecht zu. Siehe <a href="agb#widerrufsbelehrung">Widerrufsbelehrung</a>.</p>

        <h3>5. Kein Widerrufsrecht für Unternehmer</h3>
        <p>Für Unternehmer besteht kein Widerrufsrecht gemäß § 312g Abs. 2 BGB.</p>

        <h3>6. Preise und Versandkosten</h3>
        <p>Alle Preise verstehen sich inklusive der gesetzlichen Umsatzsteuer. Für Unternehmer werden die Preise netto zzgl. gesetzlicher Umsatzsteuer angezeigt. Versandkosten werden separat ausgewiesen.</p>

        <h3>7. Lieferung</h3>
        <p>Lieferungen erfolgen an die vom Kunden angegebene Lieferadresse. Unsere Lieferungen erfolgen gemäß einem festen Tourenplan, der auf Ihre Region abgestimmt ist. Bitte beachten Sie, dass die Liefertermine je nach Ihrem Standort variieren können.


            Ihre Bestellung wird an dem für Ihre Region festgelegten Liefertag zugestellt. Ihren Liefertermin können Sie vor Abgabe der Bestellung auswählen. Eine Übersicht über unsere Liefergebiete und die jeweiligen Liefertage finden Sie hier im Kopfbereich unter Liefertage.Lieferzeiten entnehmen Sie bitte dem Tourenplan.</p>

        <h3>8. Zahlung</h3>
        <p>Die verfügbaren Zahlungsarten werden im Bestellprozess angegeben.</p>

        <h3>9. Eigentumsvorbehalt</h3>
        <p>Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum. Bei Unternehmern behalten wir uns das Eigentum an der Ware bis zur vollständigen Begleichung aller Forderungen aus der laufenden Geschäftsbeziehung vor.</p>

        <h3>10. Mängelhaftung</h3>
        <p>Für Verbraucher gelten die gesetzlichen Mängelhaftungsrechte.</p>
        <p>Für Unternehmer gilt: Die Verjährungsfrist für Mängelansprüche beträgt ein Jahr ab Gefahrübergang. Die gesetzlichen Verjährungsfristen bei Rückgriffsansprüchen nach § 478 BGB bleiben unberührt.</p>

        <h3>11. Haftung</h3>
        <p>Wir haften uneingeschränkt für Vorsatz und grobe Fahrlässigkeit sowie bei Verletzung des Lebens, des Körpers oder der Gesundheit. Bei leichter Fahrlässigkeit haften wir nur bei Verletzung einer wesentlichen Vertragspflicht (Kardinalpflicht).</p>

        <h3>12. OS-Plattform und Verbraucherstreitbeilegung</h3>
        <p>Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank">https://ec.europa.eu/consumers/odr</a></p>
        <p>Wir nehmen nicht an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.</p>

        <h3>13. Datenschutz</h3>
        <p>Unsere Datenschutzerklärung finden Sie unter: <a href="/datenschutzerklaerung">/datenschutz</a>.</p>

        <h3>14. Anwendbares Recht</h3>
        <p>Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. </p>

        <h2 id="widerrufsbelehrung" class="mt-6">15. Widerrufsbelehrung für Verbraucher</h2>
        <iw-shop-dynamic-page-default-withdrawal [title]="false"></iw-shop-dynamic-page-default-withdrawal>

    </div>
